export var getVideoUrl = function (videoHost) { return function (pathname) {
    return pathname && videoHost ? "https://".concat(videoHost, "/").concat(pathname) : '';
}; };
//# sourceMappingURL=video.js.map